import { RoleType } from "../../types/Role";
import { post } from "../../utils/axios-config";
import { ROLES } from "../../utils/constants";

export const createRole = async (data: RoleType) => await post<RoleType, string>(ROLES, data);